import { useIntl } from 'react-intl';
import css from 'src/utils/css';

const classes = css`
  .container {
    align-items: center;
    color: #64748b;
    display: inline-flex;
    font-size: 12px;
    gap: 8px;
  }

  .badge {
    background: #e6f7fb;
    border: 1px solid #bdeaf2;
    border-radius: 999px;
    color: #0f7180;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    padding: 6px 10px;
  }
`;

const TipoFormularioIdentificacao = ({ tipoFormulario }) => {
  const intl = useIntl();

  if (!tipoFormulario) return null;

  const descricao = tipoFormulario.label ? intl.formatMessage({ id: tipoFormulario.label }) : tipoFormulario.id;

  return (
    <div className={classes.container}>
      <span>{intl.formatMessage({ id: 'labelTipoFormulario' }) }</span>
      <span className={classes.badge}>{descricao}</span>
    </div>
  );
};

export default TipoFormularioIdentificacao;
